// eslint-disable-line no-unused-expressions
import React from "react";

import Backdrop from "../../../../../Components/UI/Backdrop/Backdrop";
import InfoTable, {
  InfoRow,
} from "../../../../../Components/PagesComponents/AnalysisReports/InfoTable/InfoTable";

import "./styles.scss";

const HostInformationCard = ({ clientID, hostData }) => {
  return (
    <div className="thunter-information-card">
      <Backdrop show={false} absolute={true} />
      <h3 className="article">Host Information</h3>
      <InfoTable>
        <InfoRow label="Client ID" value={clientID} mono={true} />
        <InfoRow label="Host Name" value={hostData["hostname"]} />
        <InfoRow label="MAC Address" value={hostData["macaddress"]} mono={true} />
        <InfoRow label="CPU ID" value={hostData["cpuid"]} mono={true} />
      </InfoTable>
    </div>
  );
};

export default HostInformationCard;
